import type { ComponentProps } from "react"

import { cn } from "../lib/cn"

function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="skeleton" className={cn("animate-pulse rounded-md bg-muted", className)} {...props} /> // anti-ia-ok: pulsação nativa do Tailwind (sem plugin), estado de carregamento — não enfeite
}

export { Skeleton }
